import moment from 'moment'

const timestampAFecha2 = (unix_timestamp, orden='mes') => {

    const date = new Date(unix_timestamp * 1000);
    const anio = date.getFullYear();
    const mes = ("0" + (date.getMonth() + 1)).slice(-2);
    const dia = ("0" + date.getDate()).slice(-2);
    let resultado = '';
    if(orden=='mes'){
        resultado = `${mes}/${dia}/${anio}`;
    } else if(orden=='anio'){
        resultado = `${anio}/${mes}/${dia}`;
    }
    return resultado;

}

const asignaPeriodoNoProporcional = (servicio) => {

    var s_f = timestampAFecha2(servicio.info_entrada.fecha.seconds,'anio');
    var fecha_entrada =moment(s_f).format('YYYY/MM/DD');
    var fecha_salida = moment();
    servicio.info_salida.hora = moment().format('HH:mm:ss');
    var hora_inicio = (servicio.info_entrada.hora+":00").split(":")
    var hora_salida = (servicio.info_salida.hora).split(":");
    var dias=fecha_salida.diff(fecha_entrada,"days");
    var cantidad = dias/+servicio.extras.cantidad;
    (cantidad%1!=0) && (cantidad+=0.5)
    var dias_no_proporcional = (Math.round(cantidad)<1) ? 1 : Math.round(cantidad)+1;
    var info = {};
    info.fecha_entrada = fecha_entrada;
    info.fecha_salida = fecha_salida;
    info.hora_inicio = hora_inicio;
    info.hora_salida = hora_salida;
    info.dias = dias;
    info.cantidad = cantidad;
    info.dias_no_proporcional = dias_no_proporcional;
    if(servicio.extras.periodo=="Día"){
       return asignaCantidadNoProporcionalDias(dias_no_proporcional);
    } else if(servicio.extras.periodo=="Hora"){
       return asignaCantidadNoProporcionalHoras(info, servicio.extras.cantidad);
    } else if(servicio.extras.periodo=="Minuto"){
      info.hora1 = hora_inicio;
      info.hora2 = hora_salida;
      return asignaCantidadNoProporcionalMinutos(info,servicio);
    }
}

const asignaPeriodoProporcional = (servicio) => {

    var inicio_temp = timestampAFecha2(servicio.info_entrada.fecha.seconds,'anio');
    var fecha_entrada =moment(inicio_temp).format('YYYY/MM/DD');
    var fecha_salida = moment();
    var dias=fecha_salida.diff(fecha_entrada,"days");
    var minutos = fecha_salida.diff(fecha_entrada,"minuts")
    servicio.info_salida.hora = moment().format('HH:mm:ss');

    var hora1 = (servicio.info_entrada.hora+":00").split(":")
    var hora2 = (servicio.info_salida.hora).split(":");
    var t1 = new Date(); 
    var t2 = new Date();
    var t3 = new Date();
    t2.setHours(hora1[0], hora1[1], hora1[2]);
    t1.setHours(hora2[0], hora2[1], hora2[2]);
    t3.setHours(t1.getHours() - t2.getHours(), t1.getMinutes() - t2.getMinutes(), 
    t1.getSeconds() - t2.getSeconds());

    var info = {};
    info.fecha_entrada = fecha_entrada;
    info.fecha_salida = fecha_salida;
    info.dias = dias;
    info.minutos= minutos
    info.hora1 = hora1;
    info.hora2 = hora2;
    info.t1 = t1;
    info.t2 = t2;
    info.t3 = t3;

    if(servicio.extras.periodo=="Día"){
        return asignaCantidadProporcionalDias(info,servicio);
    } else if(servicio.extras.periodo=="Hora"){
        return asignaCantidadProporcionalHoras(info,servicio);
    } else if(servicio.extras.periodo=="Minuto"){
        return asignaCantidadProporcionalMinutos(info,servicio);
    }
}

const asignaCantidadProporcionalMinutos = (info, servicio) => {
   
    var fecha1 = moment(info.fecha_entrada+' ' +
    info.hora1[0]+':'+info.hora1[1]+':'+info.hora1[2] ,'YYYY/MM/DD HH:mm:ss')
    var hoy = moment().format('YYYY/MM/DD')
    var fecha2 = moment(hoy+' '+info.hora2[0]+':'+info.hora2[1]+':'+info.hora2[2])

    var diff = fecha2.diff(fecha1, 'm')
    var resultado = Math.trunc(diff/(+servicio.extras.cantidad))
    
    var cantidad = resultado!=0 ? resultado : 1;
    console.log("total, minutos",cantidad)
    return cantidad
}

const asignaCantidadProporcionalDias = (info,servicio, es_servicio=false) => {

    if(!es_servicio){
        var cantidad = info.dias/+servicio.extras.cantidad;
    } else {
        var cantidad = info.dias/+servicio;
    }
    info.fecha_salida = moment();
    var cantidad_retorna = 0;
    (cantidad%1!=0) && (cantidad+=0.5)
    var horas = info.t3.getHours();
    if(info.dias>=1){
      if(info.hora1[0]>info.hora2[0]){
        var tempCantidad = (+cantidad-1)
        ////console.log(tempCantidad)
        cantidad_retorna = (tempCantidad + (+horas/24)).toFixed(2);
      } else if(info.hora1[0]<=info.hora2[0]){
        var tempCantidad = (+cantidad)
        if(info.hora1[0]==info.hora2[0]){
          ////console.log("HORAS IGUALES")
          if(info.hora2[1]<info.hora1[1]){
            ////console.log("HORA SALIDA MENOR A HORA INICIO")
            tempCantidad = (+cantidad)-1;
          }
        }
        cantidad_retorna = (( tempCantidad ) + ( horas/24) ).toFixed(2);
      } else if(cantidad==0 && (info.hora2[0] == info.hora1[0] ) ){
        cantidad_retorna = 0;
      }
    } else if(info.dias==0){
      ////console.log("DIA CERO")
      if(info.hora2[0]>=info.hora1[0]){
        ////console.log("Hora de salida mayor a hora de inicio")
        cantidad_retorna = (horas/24).toFixed(2);
        if(info.hora2[1]>info.hora1[1]){
            cantidad_retorna = (horas/24).toFixed(2);
        }
      }
    }

    return cantidad_retorna;
}

const asignaCantidadProporcionalHoras = (info) => {
    var fecha1 = moment(info.fecha_entrada+' ' +
    info.hora1[0]+':'+info.hora1[1]+':'+info.hora1[2] ,'YYYY/MM/DD HH:mm:ss')
    var hoy = moment().format('YYYY/MM/DD')
    var fecha2 = moment(hoy+' '+info.hora2[0]+':'+info.hora2[1]+':'+info.hora2[2])

    var diff = fecha2.diff(fecha1, 'h')
    var minutos_transcurridos = fecha2.diff(fecha1, 'm')
    var cantidad = (minutos_transcurridos/60)
    return cantidad
    //return resultado;
}

const asignaCantidadNoProporcionalDias = (dias) => {
    return dias;
}

const asignaCantidadNoProporcionalHoras = (info, cantidadParametro) => {
   
    var fecha1 = moment(info.fecha_entrada+' ' +
    info.hora_inicio[0]+':'+info.hora_inicio[1]+':'+info.hora_inicio[2] ,'YYYY/MM/DD HH:mm:ss')
    var hoy = moment().format('YYYY/MM/DD')
    var fecha2 = moment(hoy+' '+info.hora_salida[0]+':'+info.hora_salida[1]+':'+info.hora_salida[2])
    var diff_hora = fecha2.diff(fecha1, 'h')
    var min_extra = fecha2.diff(fecha1,'m')
    var total = 0;
    if(diff_hora==0 && diff_hora<=cantidadParametro){
      if(min_extra>0) total = 1
    } else{
      if(diff_hora%cantidadParametro==0){
        var minutos = (min_extra/60/cantidadParametro)
        if(minutos>0) total = 1
      }
    }
    var resultado = Math.trunc(diff_hora/(+cantidadParametro)) + total;
    return resultado!=0 ? resultado : 1;

  }

  const asignaCantidadNoProporcionalMinutos =(info, cantidadParametro)=>{
    var fecha1 = moment(info.fecha_entrada+' ' +
    info.hora1[0]+':'+info.hora1[1]+':'+info.hora1[2] ,'YYYY/MM/DD HH:mm:ss')
    var hoy = moment().format('YYYY/MM/DD')
    var fecha2 = moment(hoy+' '+info.hora2[0]+':'+info.hora2[1]+':'+info.hora2[2])

    var diff = fecha2.diff(fecha1, 'm')
    var resultado = Math.trunc(diff/(+servicio.extras.cantidad))
    return resultado!=0 ? resultado : 1;

  }

const calcularTotalPeriodos = (precio, cantidad) =>{
    return ((+precio * +cantidad) ).toFixed(2);
}

const calcularPrecioHospitalizacion = (item) => {

    if (item.tipo == "Hospitalizacion" || item.tipo == "Hotel" || item.tipo == "Hospitalización") {
        
        if (!item.completado) {
            var cantidad = 0;
            //console.log("TCL: indiceCasosVista -> item.extras.es_proporcional", item.extras)
            if (item.extras.es_proporcional) {
                //console.log("Cantidad proporcional asignada: " + this.asignaPeriodoProporcional(item));
                cantidad = asignaPeriodoProporcional(item);
                //console.log('%c'+this.asignaPeriodoProporcional(item)+'background: red; color: #bada55');
            } else {
                //console.log("Cantidad no proporcional asignada")
                //console.log('%c'+this.asignaPeriodoNoProporcional(item)+'background: red; color: #bada55');
                cantidad = asignaPeriodoNoProporcional(item);
            }
            item.cantidad = cantidad;
            item.total = calcularTotalPeriodos(item.precio, item.cantidad);
            item.subtotal = calcularTotalPeriodos(item.precio, item.cantidad);
        }
    }

}

export {
    calcularTotalPeriodos,
    asignaCantidadNoProporcionalDias,
    asignaCantidadNoProporcionalHoras,
    asignaCantidadNoProporcionalMinutos,
    asignaCantidadProporcionalDias,
    asignaCantidadProporcionalHoras,
    asignaCantidadProporcionalMinutos,
    asignaPeriodoProporcional,
    asignaPeriodoNoProporcional,
    calcularPrecioHospitalizacion
}


// WEBPACK FOOTER //
// ./src/constantes/casos/hospitalizacion.js